import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css';

const TermsConditions = () => {
  return (
    <div>
    
<Helmet>
        <title>Pune to Mumbai cab On rent | Call: +91 9371304510 | Morya Cab</title>
        <meta
          name="description"
          content="Book your reliable Pune to Mumbai taxi service with Morya Cabs. We offer one-way, round trip, luxury taxis, and shared cabs for your comfortable journey."
        />
        <meta name="keywords" content="Pune to Mumbai taxi, Pune to Mumbai cab, Pune to Mumbai taxi booking, Pune to Mumbai one-way taxi, Pune to Mumbai round trip, Pune to Mumbai luxury taxi, Pune to Mumbai airport taxi" />
        <meta property="og:title" content="Pune to Mumbai Taxi | Morya Cabs" />
        <meta property="og:description" content="Book affordable and reliable Pune to Mumbai taxi service with Morya Cabs. Choose from one-way, round trip, and luxury taxis for a comfortable ride." />
        <meta property="og:url" content="https://moryacab.com/pune-to-mumbai-taxi" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://moryacab.com/img/pune-to-mumbai-taxi.jpg" />
      </Helmet>
      


    <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
    <div className="container">
      <div className="breadcumb-content">
        <h1 className="breadcumb-title">Terms & Conditions </h1>
        <ul className="breadcumb-menu">
          <li><a href="/">Home</a></li>
          <li>Terms & Conditions </li>
        </ul>
      </div>
    </div>
  </div>

      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-7">
              <div className="terms-content">
                <p><b className="highlight">1. Booking Confirmation:</b> All bookings with Morya Cab are subject to availability and will be confirmed upon receipt of full payment and issuance of a booking reference number.</p>

                <p><b className="highlight">2. Payment:</b> Payments must be completed at the time of booking via our secure online portal or authorized payment methods.</p>

                <p><b className="highlight">3. Cancellation and Rescheduling:</b> Changes or cancellations to bookings must comply with our cancellation policy, which may include applicable fees based on the timing of the request.</p>

                <p><b className="highlight">4. Passenger Responsibility:</b> Passengers must carry valid identification and booking confirmations. Morya Cab reserves the right to deny service without proper documentation.</p>

                <p><b className="highlight">5. Baggage Policy:</b> Passengers may bring a limited amount of baggage per booking. Excess baggage may incur additional charges.</p>

                <p><b className="highlight">6. Travel Insurance:</b> While we ensure a safe journey, we recommend obtaining travel insurance for unforeseen circumstances.</p>

                <p><b className="highlight">7. Safety Regulations:</b> All passengers must adhere to safety guidelines and driver instructions to ensure a secure journey.</p>

                <p><b className="highlight">8. Changes to Itinerary:</b> Morya Cab reserves the right to adjust routes or schedules due to weather, traffic, or other unforeseen conditions.</p>

                <p><b className="highlight">9. Refusal of Service:</b> We may refuse service to passengers exhibiting inappropriate behavior, violating terms, or compromising safety.</p>

                <p><b className="highlight">10. Jurisdiction:</b> These terms are governed by Indian laws, and any disputes will be settled in Pune jurisdiction.</p>

                <h3>General Policy</h3>
                <p><b className="highlight">Booking Procedure:</b> Book your cab via our website or customer service helpline for a seamless experience.</p>
                <p><b className="highlight">Customer Support:</b> Our dedicated team is available 24/7 to address your questions and concerns.</p>

                <h3>Refund Policy</h3>
                <p><b className="highlight">Cancellation Fees:</b> Refunds may be subject to cancellation charges based on the timing of the request.</p>
                <p><b className="highlight">Refund Process:</b> Refunds will be processed within 7-10 business days through the original payment method.</p>
                <p><b className="highlight">No-Show Policy:</b> No-shows are not eligible for refunds or rescheduling.</p>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions or need clarification about our terms, feel free to reach out:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+919371304510">+91 9371304510</a></li>
              <li><b>Email:</b> <a href="mailto:booking@moryacab.com">booking@moryacab.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
